export default __webpack_public_path__ + "static/media/proxima_nova_black.cb4a04f0.ttf";